/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_steps_where_start_description = /** @type {(inputs: {}) => string} */ () => {
	return `Sin importar donde esté tu empresa, te hacemos global`
};

const en_organization_steps_where_start_description = /** @type {(inputs: {}) => string} */ () => {
	return `No matter where your company is, we make you global`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_steps_where_start_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_steps_where_start_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_steps_where_start_description", locale)
	if (locale === "es") return es_organization_steps_where_start_description(inputs)
	return en_organization_steps_where_start_description(inputs)
};
export { organization_steps_where_start_description as "organization.steps.where_start_description" }